import React from 'react';
import './contactus.css';
import logo from '../assets/Logo.png';
import email from '../assets/email-icon.png';
import phone from '../assets/phone-icon.png';

function Contact() {
  return (
    <div className="contact-page">
      <img src={logo} alt="Akhila Kerala Balajanasakhyam Logo" className="contact-logo" />

      {/* About Us Section */}
     
      <h1>CONTACT US</h1>

      <div className="contact-container">
        <h2>Get in Touch</h2>

        <div className="contact-item">
          <img src={email} alt="Email" className="contact-icon" />
          <a href="mailto:balajanasakhyam@mm.co.in"><strong>balajanasakhyam@mm.co.in</strong></a>
        </div>

        <div className="contact-item">
          <img src={phone} alt="Phone" className="contact-icon" />
          <p><strong>+91 98953 99491</strong></p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
